'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {

	/**
	 * Checks the article quantity value to match interval and minimumOrderQuantity constraints
	 * @param articleQuantity
	 * @param minimumOrderQuantity
	 * @param orderQuantityInterval
	 * @returns {*}
	 */
	function checkQuantity(articleQuantity, minimumOrderQuantity, orderQuantityInterval) {
		if (articleQuantity > minimumOrderQuantity) {
			if (((articleQuantity - minimumOrderQuantity) % orderQuantityInterval !== 0)) {
				return Math.floor(((articleQuantity - minimumOrderQuantity) / orderQuantityInterval) + 1) * orderQuantityInterval + minimumOrderQuantity;
			} else {
				return articleQuantity
			}
		} else {
			return minimumOrderQuantity;
		}
	}

	function formatPrice(price) {
		var formatted = price.amount.value * Math.pow(10, -(price.amount.decimalDigits));
		return formatted.toLocaleString(
			undefined, // leave undefined to use the browser's locale,
			// or use a string like 'en-US' to override it.
			{minimumFractionDigits: 2}
		) + (price.hasOwnProperty('currency') ? ' ' + price.currency : '');
	}

	function getBusinessShopIdFromSingleArticle(article, customerId, supplierId) {
		var businessShopLink = article.schema.links.find(function (link) {
			return link.rel === 'business-shop';
		});
		if (typeof businessShopLink !== "undefined") {
			var businessShopPath = new URL(businessShopLink.href).pathname.split('/');
			return businessShopPath[businessShopPath.length - 1];
		} else {
			return '';
		}
	}

	function formatAmount(amount) {
		var formatted = amount.value * Math.pow(10, -(amount.decimalDigits));
		return formatted.toLocaleString(
			undefined, // leave undefined to use the browser's locale,
			// or use a string like 'en-US' to override it.
			{minimumFractionDigits: 0}
		)
	}

	return {
		search:
			$resource(
				apiConfig.$get().apiUrl + '/unite/search?q=:search&customer=:customer&supplier=:supplier&offset=:offset&limit=:limit:catalogId',
				{
					search: '@search',
					customer: '@customer',
					supplier: '@supplier',
					offset: '@offset',
					limit: '@limit',
					catalogId: '@catalogId'
				}
			),
		getArticleById:
			$resource(
				apiConfig.$get().apiUrl + '/unite/article/:articleId?supplier=:supplier&customer=:customer',
				{
					articleId: '@articleId',
					supplier: '@supplier',
					customer: '@customer',
				}
			),
		getCatalogInfo:
			$resource(
				apiConfig.$get().apiUrl + '/unite/details?customer=:customer&supplier=:supplier&businessShopId=:businessShopId',
				{
					customer: '@customer',
					supplier: '@supplier',
					businessShopId: '@businessShopId'
				}
			),
		checkUniteArticleQuantity: checkQuantity,
		getBusinessShopIdFromSingleArticle: getBusinessShopIdFromSingleArticle,
		formatAmount: formatAmount,
		formatPrice: formatPrice
	};
}
